export function truncatedSelectionValue(value: string | null | undefined) {
  const label = value || '-';
  return (
    <span className="block truncate" title={label}>
      {label}
    </span>
  );
}
